type BackendWriteListener = (operation: string) => void;

const listeners = new Set<BackendWriteListener>();

export const reportBackendWrite = (operation: string): void => {
  for (const listener of listeners) {
    listener(operation);
  }
};

export const subscribeToBackendWrites = (
  listener: BackendWriteListener,
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
